import React from 'react';
import { motion } from 'framer-motion';
import './Button.css';

/**
 * Button - Modern button with purple primary
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.variant - 'primary' | 'secondary' | 'ghost' | 'outline'
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {boolean} props.fullWidth
 * @param {boolean} props.disabled
 */
export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}) => {
  const classes = `btn btn-${variant} btn-${size} ${fullWidth ? 'btn-full' : ''} ${className}`.trim();

  return (
    <motion.button
      className={classes}
      whileHover={!props.disabled ? { scale: 1.02 } : {}}
      whileTap={!props.disabled ? { scale: 0.98 } : {}}
      transition={{ duration: 0.15 }}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;
